<app-base-bar-chart
[chartId]="chartId"
[title]="title"
[dataset]="dataset"
[labels]="labels"
>
</app-base-bar-chart>